module.exports = __webpack_public_path__ + "img/04.cc37b32f.png";